import { render, staticRenderFns } from "./OsTargetProfileOverview.vue?vue&type=template&id=573e8080&scoped=true"
import script from "./OsTargetProfileOverview.vue?vue&type=script&lang=ts"
export * from "./OsTargetProfileOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e8080",
  null
  
)

export default component.exports